var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "area-selection" },
    [
      _c("section-title", {
        attrs: { "has-line": "", title: "Seleccionar Área Académica" }
      }),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-row justify-content-between align-items-start"
        },
        [
          _c(
            "div",
            { staticClass: "col-5 pr-3 border-right" },
            [
              _c("label", { staticClass: "d-block mb-2" }, [
                _vm._v("Áreas del PEI:")
              ]),
              _c("validation-provider", {
                ref: "areaValidator",
                attrs: { name: "customDropDownArea" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-drop-down", {
                          attrs: {
                            id: "area",
                            clearable: false,
                            "custom-error-msg": "Favor seleccionar un área.",
                            error: errors[0],
                            fieldkey: "id",
                            fieldname: "name",
                            options: _vm.availableAreaOptions,
                            placeholder: "Seleccione"
                          },
                          model: {
                            value: _vm.model.area,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "area", $$v)
                            },
                            expression: "model.area"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c(
                "div",
                { staticClass: "row mt-3 mr-1 d-flex justify-content-end" },
                [
                  _c("action-button", {
                    attrs: {
                      id: "btnAdd",
                      i: "fas fa-file-plus fa-lg",
                      text: "Añadir",
                      variant: "success"
                    },
                    on: { click: _vm.onAddHandler }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "col-7 pl-3" }, [
            _c("label", { staticClass: "d-block mb-2" }, [
              _vm._v(" Áreas Seleccionadas: ")
            ]),
            _c("div", { staticClass: "py-2 px-1" }, [
              _c(
                "div",
                _vm._l(_vm.localSelected, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: `reason-item-${index}`,
                      staticClass:
                        "reason-item px-3 py-1 d-inline-block mr-2 my-2"
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "color-black font-16 font-weight-bold" },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      ),
                      _c("i", {
                        staticClass:
                          "far fa-times-circle text-red font-16 cursor-pointer ml-2",
                        on: {
                          click: function($event) {
                            return _vm.onDeleteItemHandler(index)
                          }
                        }
                      })
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }